export default class Vereine {
    Prim = 0;
    Name = "";
    Stadt = "";
    PLZ = "";
    NWTUVerein = false;
}
